import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container } from 'semantic-ui-react';
import { IWorkstation } from '@relab/alstom-ptw-shared';

import { HeaderComponent } from '../components/HeaderComponent';
import { NavBar } from '../components/NavBar';
import { WorkstationCreateComponent } from '../components/workstation/WorkstationCreateComponent';
import { appState, appStateServerRequests } from '../redux/selectors';
import { ActionType, RootState, ServerRequestStatus } from '../redux/types';
import { workstationCreateAction, workstationsAction } from '../redux/actions';
import { WorkstationsListComponent } from '../components/workstation/WorkstationsListComponent';

interface WorkstationsSceneProps extends Component {
  workstationsAction: typeof workstationsAction;
  workstations: IWorkstation[];
  workstationCreateAction: typeof workstationCreateAction;
  createWorkstationServerRequest?: ServerRequestStatus;
}

class PWorkstationsScene extends Component<WorkstationsSceneProps> {
  componentDidMount() {
    this.props.workstationsAction();
  }

  render() {
    const { createWorkstationServerRequest, workstations, workstationCreateAction } = this.props;

    return (
      <React.Fragment>
        <HeaderComponent />
        <NavBar />
        <Container fluid>
          <WorkstationCreateComponent
            onCreateWorkstation={workstationCreateAction}
            createWorkstationServerRequest={createWorkstationServerRequest}
          />
          <WorkstationsListComponent workstations={workstations} />
        </Container>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  workstations: appState(state).workstations,
  createWorkstationServerRequest: appStateServerRequests(state, ActionType.WORKSTATION_CREATE),
});

export const WorkstationsScene = connect(mapStateToProps, { workstationsAction, workstationCreateAction })(
  PWorkstationsScene
);
